import React from "react";
import PropTypes from "prop-types";
import { DialysisBand } from "../DialysisBand";
import { DIALYSIS_TYPE } from "../DialysisDragDrop.constants";
import { DialysisDragDropContext } from "../DialysisDragDrop.utils";

export function DialysisHolder(props) {
  const { state, onDragOver, onStripDrop, isMultiDialysisHolder } =
    React.useContext(DialysisDragDropContext);

  const TYPE = "DIALYSIS_HOLDER";

  const style = { height: `${state.dialysisHolderBoxHeight}px` };

  const setInnerText = (dialysis) => {
    let text = null;
    if (isMultiDialysisHolder) text = `${dialysis.dialysisId + 1}`;
    return text;
  };

  const renderDialysisBand = (dialysisBand) => (
    <DialysisBand
      id={props.id}
      key={dialysisBand.dialysisId}
      type={TYPE}
      dialysisId={`${props.cellId}_${dialysisBand.dialysisId}`}
      dialysisType={dialysisBand.dialysisType}
      height={dialysisBand.height}
      opacity={dialysisBand.opacity}
      value={dialysisBand.value}
      className={`${props.className}__dialysisBox__band`}
      selected={dialysisBand.selected}
      label={props.label}
      tabIndex={props.tabIndex}
      colId={props.colId}
      feedbackType={props.feedbackType}
      responses={props.responses}
    >
      {setInnerText(dialysisBand)}
    </DialysisBand>
  );

  const renderContent = () => {
    if (props.cellItems) {
      return (
        <div
          className={`${props.className}__dialysisBox`}
          style={style}
          tabIndex={props.tabIndex}
        >
          {props.cellItems.map(renderDialysisBand)}
        </div>
      );
    } else {
      return (
        <p className={`${props.className}__label`} style={style}>
          {props.label}
        </p>
      );
    }
  };

  const onDrop = (event) => {
    onStripDrop({ id: props.id, event, cellId: props.cellId, value: 0 });
  };

  return (
    <div className={props.className} onDragOver={onDragOver} onDrop={onDrop}>
      {renderContent()}
    </div>
  );
}

DialysisHolder.propTypes = {
  /**
   * Component id from the notebook data file
   */
  id: PropTypes.number,
  /**
   * ClassName to be set for the cell;
   */
  className: PropTypes.string,
  /**
   * label to display on dialysis holder
   */
  label: PropTypes.string,
  /**
   * Unique Id for the cell
   */
  cellId: PropTypes.string,
  /**
   * List of DialysisItems to be renderd here
   */
  cellItems:
    PropTypes.arrayOf(
      PropTypes.shape({
        /**
         * Unique Id for Dialysis
         */
        dialysisId: PropTypes.number,
        /**
         * Type of Dialysis-Strip
         */
        dialysisType: PropTypes.oneOf(Object.keys(DIALYSIS_TYPE)),
        /**
         * Height value go Dialysis
         */
        height: PropTypes.number,
        /**
         * Opacity value of Dialysis
         */
        opacity: PropTypes.number,
        /**
         * Postion value of Dialysis
         */
        value: PropTypes.number || null,
        /**
         * Boolean to set if dialysis band is selected
         */
        selected: PropTypes.bool,
      })
    ) || null,
  /**
   * Tabindex value passed from outside the component for keyboard navigation
   */
  tabIndex: PropTypes.number,
};

DialysisHolder.defaultProps = {
  label: null,
  tabIndex: 0,
};
